import { useState } from "react";
import { BiCopy, BiCopyAlt } from "react-icons/bi";

export default function GridDataCopyCell(items) {
  const [showButton, setShowButton] = useState(false);
  const [copied, setCopied] = useState(false);

  return (
    <td className="k-table-td">
      <div className="flex flex-row gap-2 items-start">
        <div style={{ width: "100%" }}>
          {items?.customCell ? items.customCell : items.dataItem[items.field]}
        </div>
        <button
          type="button"
          className="bg-transparent border-none p-0" // Reset button styles
          title={copied ? "Copied" : "Copy to clipboard"}
          aria-label={
            copied
              ? "Copied"
              : `Copy ${items.dataItem[items.field]} to clipboard`
          }
          onClick={async () => {
            await navigator.clipboard.writeText(items.dataItem[items.field]);
            setCopied(true);
          }}
          onMouseEnter={() => {
            setShowButton(true);
          }}
          onMouseLeave={() => {
            setShowButton(false);
            setCopied(false);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              navigator.clipboard.writeText(items.dataItem[items.field]);
              setCopied(true);
            }
          }}
          onBlur={() => {
            setCopied(false);
          }}
        >
          {copied ? (
            <BiCopyAlt
              style={
                showButton
                  ? {
                      visibility: "visible",
                      fontSize: "14px",
                      cursor: "Pointer",
                    }
                  : {
                      visibility: "hidden",
                      fontSize: "14px",
                      cursor: "Pointer",
                    }
              }
              aria-hidden="true"
            />
          ) : (
            <BiCopy
              style={
                showButton
                  ? {
                      visibility: "visible",
                      fontSize: "14px",
                      cursor: "Pointer",
                    }
                  : {
                      visibility: "hidden",
                      fontSize: "14px",
                      cursor: "Pointer",
                    }
              }
              aria-hidden="true"
            />
          )}
        </button>
      </div>
    </td>
  );
}
